import React from "react";
import { EexiData } from "../../types/EexiData";
import { Trans } from "react-i18next";
import "./Eexi.css";

type Props = {
    eexiData: EexiData;
};

export const Eexi = (props: Props) => {
    const { eexiData } = props;

    const bannerColour = eexiData.eexiScoreStatus.boxColour;
    const attainedColour = eexiData.eexiScoreStatus.colour;

    return (
        <div className="grid">
            <div className="col-6">
                <div className="col p-1 eexi_header">
                    <Trans
                        ns="common"
                        i18nKey="inspectionReport.decarbonisation.eexi.required_title"
                    />
                    :
                </div>
                <div className="col  p-1 eexi_number">
                    {eexiData.requiredEEXI}
                </div>
                <div className="col p-1 co2">gCO2/t.nm</div>
            </div>
            <div className="col-6">
                <div className={"col p-1  eexi_header"}>
                    <Trans
                        ns="common"
                        i18nKey="inspectionReport.decarbonisation.eexi.attained_title"
                    />
                    :
                </div>
                <div
                    className={"col p-1 eexi_number"}
                    style={{ color: attainedColour }}
                >
                    {eexiData.attainedRange}
                </div>
                <div className={"col p-1  co2"}>gCO2/t.nm</div>
            </div>
            <div className="col-12 pt-0">
                <div
                    className={"result_box"}
                    style={{ backgroundColor: bannerColour }}
                >
                    <div className={"result_box_text"}>
                        {eexiData.eexiRequirementSentence}
                    </div>
                </div>
            </div>
        </div>
    );
};
